import { Capacitor } from "@capacitor/core";
import { AppsFlyer } from "appsflyer-capacitor-plugin";

/** Reads AppsFlyer cache from localStorage. Safe before @um/ui registerConfig (no Firebase). */
export function getAttributionData() {
  function readCachedData(fieldName: string) {
    const attributionData = localStorage.getItem(fieldName);
    return attributionData ? JSON.parse(attributionData) : undefined;
  }
  return {
    attributionData: readCachedData("attributionData"),
    deepLinkData: readCachedData("deepLinkData"),
    conversionData: readCachedData("conversionData"),
  };
}

export async function setUserId(userId: string) {
  if (Capacitor.isNativePlatform()) {
    console.log(`[social] AppsFlyer setCustomerUserId`, userId);

    await AppsFlyer.setCustomerUserId({
      cuid: userId,
    });
  }
}
